import AddRoomCategory from "../pages/ipd/master/roomCategory/add";
import ListRoomCategory from "../pages/ipd/master/roomCategory/list";
import EditRoomCategory from "../pages/ipd/master/roomCategory/edit";

import AddNursingStation from "../pages/ipd/master/nursingStation/add";
import ListNursingStation from "../pages/ipd/master/nursingStation/list";
import EditNursingStation from "../pages/ipd/master/nursingStation/edit";

import AddRoom from "../pages/ipd/master/room/add";
import ListRoom from "../pages/ipd/master/room/list";
import EditRoom from "../pages/ipd/master/room/edit";

// ipd-transaction
import AddIpdEntry from "../pages/ipd/transaction/ipdEntry/add";
import ListIpdEntry from "../pages/ipd/transaction/ipdEntry/list";
import EditIpdEntry from "../pages/ipd/transaction/ipdEntry/edit";
import ViewIpdEntry from "../pages/ipd/transaction/ipdEntry/view";

import AddPaymentReceiveEntry from "../pages/ipd/transaction/paymentReceiveEntry/add";
import ListPaymentReceiveEntry from "../pages/ipd/transaction/paymentReceiveEntry/list";
import EditPaymentReceiveEntry from "../pages/ipd/transaction/paymentReceiveEntry/edit";
import ViewPaymentReceiveEntry from "../pages/ipd/transaction/paymentReceiveEntry/view";

import AddRoomChangeEntry from "../pages/ipd/transaction/roomChangeEntry/add";
import ListRoomChangeEntry from "../pages/ipd/transaction/roomChangeEntry/list";
import EditRoomChangeEntry from "../pages/ipd/transaction/roomChangeEntry/edit";

import AddIpdBillChargesEntry from "../pages/ipd/transaction/ipdBillChargesEntry/add";
import ListIpdBillChargesEntry from "../pages/ipd/transaction/ipdBillChargesEntry/list";
import EditIpdBillChargesEntry from "../pages/ipd/transaction/ipdBillChargesEntry/edit";

import AddDeliveryEntry from "../pages/ipd/transaction/deliveryEntry/add";
import ListDeliveryEntry from "../pages/ipd/transaction/deliveryEntry/list";
import EditDeliveryEntry from "../pages/ipd/transaction/deliveryEntry/edit";

import AddPatientHistoryEntry from "../pages/ipd/transaction/patientHistoryEntry/add";
import ListPatientHistoryEntry from "../pages/ipd/transaction/patientHistoryEntry/list";
import EditPatientHistoryEntry from "../pages/ipd/transaction/patientHistoryEntry/edit";

import AddIpdRefundEntry from "../pages/ipd/transaction/ipdRefundEntry/add";
import ListIpdRefundEntry from "../pages/ipd/transaction/ipdRefundEntry/list";
import EditIpdRefundEntry from "../pages/ipd/transaction/ipdRefundEntry/edit";

import AddPatientDischargeEntry from "../pages/ipd/transaction/patientDischargeEntry/add";
import ListPatientDischargeEntry from "../pages/ipd/transaction/patientDischargeEntry/list";
import EditPatientDischargeEntry from "../pages/ipd/transaction/patientDischargeEntry/edit";

import AddDischargeCardEntry from "../pages/ipd/transaction/dischargeCardEntry/add";
import ListDischargeCardEntry from "../pages/ipd/transaction/dischargeCardEntry/list";
import EditDischargeCardEntry from "../pages/ipd/transaction/dischargeCardEntry/edit";

import AddIpdMedicalCertificateEntry from "../pages/ipd/transaction/ipdMedicalCertificateEntry/add";
import ListIpdMedicalCertificateEntry from "../pages/ipd/transaction/ipdMedicalCertificateEntry/list";
import EditIpdMedicalCertificateEntry from "../pages/ipd/transaction/ipdMedicalCertificateEntry/edit";

import AddMlcEntry from "../pages/ipd/transaction/mlcEntry/add";
import ListMlcEntry from "../pages/ipd/transaction/mlcEntry/list";
import EditMlcEntry from "../pages/ipd/transaction/mlcEntry/edit";

import AddOxygenGivenEntry from "../pages/ipd/transaction/oxygenGivenEntry/add";
import ListOxygenGivenEntry from "../pages/ipd/transaction/oxygenGivenEntry/list";
import EditOxygenGivenEntry from "../pages/ipd/transaction/oxygenGivenEntry/edit";

import AddDeathCertificateEntry from "../pages/ipd/transaction/deathCertificateEntry/add";
import ListDeathCertificateEntry from "../pages/ipd/transaction/deathCertificateEntry/list";
import EditDeathCertificateEntry from "../pages/ipd/transaction/deathCertificateEntry/edit";

import AddIpdConsultantChange from "../pages/ipd/transaction/ipdConsultantChange/add";
import ListIpdConsultantChange from "../pages/ipd/transaction/ipdConsultantChange/list";
import EditIpdConsultantChange from "../pages/ipd/transaction/ipdConsultantChange/edit";

// ipd-reports
import IpdRegistrationReport from "../pages/ipd/reports/ipdRegistrationReport";
import BirthReport from "../pages/ipd/reports/birthReport";
import MtpReport from "../pages/ipd/reports/MtpReport";
import RoomChangeReport from "../pages/ipd/reports/roomChangeReport";
import DischargeReport from "../pages/ipd/reports/dischargeReport";
import DischargePatientStatusReport from "../pages/ipd/reports/dischargePatientStatusReport";
import DischargePatientDuesReport from "../pages/ipd/reports/dischargePatientDuesReport";
import DoctorWisePatientStatusReport from "../pages/ipd/reports/doctorWisePatientStatusReport";
import InPatientReport from "../pages/ipd/reports/inPatientReport";
import DepartmentCensusReport from "../pages/ipd/reports/departmentCensusReport";
import DischargeBillReport from "../pages/ipd/reports/dischargeBillReport";
import DiscountReport from "../pages/ipd/reports/discountReport";
import IpdChargesReport from "../pages/ipd/reports/ipdChargesReport";
import IpdGroupWiseChargesReport from "../pages/ipd/reports/ipdGroupWiseChargesReport";
import IpdPatientConsultantWiseReport from "../pages/ipd/reports/ipdPatientConsultantWiseReport";
import IpdPatientReceiptsReport from "../pages/ipd/reports/ipdPatientReceiptsReport";
import MlcReport from "../pages/ipd/reports/mlcReport";
import IpdRefundReport from "../pages/ipd/reports/ipdRefundReport";
import RoomCategoryWiseReport from "../pages/ipd/reports/roomCategoryWiseReport";
import IpdGenderWiseReport from "../pages/ipd/reports/ipdGenderWiseReport";

export const ipdMasterRoutes = [
  // room-category
  {
    path: `/ipd/master/room-category/add`,
    Component: <AddRoomCategory />,
    permission: "roomcategory.add"
  },
  {
    path: `/ipd/master/room-category/list`,
    Component: <ListRoomCategory />,
    permission: "roomcategory.list"
  },
  {
    path: `/ipd/master/room-category/edit/:id`,
    Component: <EditRoomCategory />,
    permission: "roomcategory.edit"
  },

  // nursing-station
  {
    path: `/ipd/master/nursing-station/add`,
    Component: <AddNursingStation />,
    permission: "nursingstation.add"
  },
  {
    path: `/ipd/master/nursing-station/list`,
    Component: <ListNursingStation />,
    permission: "nursingstation.list"
  },
  {
    path: `/ipd/master/nursing-station/edit/:id`,
    Component: <EditNursingStation />,
    permission: "nursingstation.edit"
  },

  // room
  {
    path: `/ipd/master/room/add`,
    Component: <AddRoom />,
    permission: "room.add"
  },
  {
    path: `/ipd/master/room/list`,
    Component: <ListRoom />,
    permission: "room.list"
  },
  {
    path: `/ipd/master/room/edit/:id`,
    Component: <EditRoom />,
    permission: "room.edit"
  }
];

export const ipdTransactionRoutes = [
  // ipd-entry
  {
    path: `/ipd/transaction/Ipd-entry/add`,
    Component: <AddIpdEntry />,
    permission: "ipdregistration.add"
  },
  {
    path: `/ipd/transaction/ipd-entry/list`,
    Component: <ListIpdEntry />,
    permission: "ipdregistration.list"
  },
  {
    path: `/ipd/transaction/ipd-entry/edit/:id`,
    Component: <EditIpdEntry />,
    permission: "ipdregistration.edit"
  },
  {
    path: `/ipd/transaction/ipd-entry/view/:id`,
    Component: <ViewIpdEntry />,
    permission: "ipdregistration.view"
  },

  // payment-receive-entry
  {
    path: `/ipd/transaction/payment-receive-entry/add`,
    Component: <AddPaymentReceiveEntry />,
    permission: "paymentreceive.add"
  },
  {
    path: `/ipd/transaction/payment-receive-entry/list`,
    Component: <ListPaymentReceiveEntry />,
    permission: "paymentreceive.list"
  },
  {
    path: `/ipd/transaction/payment-receive-entry/edit/:id`,
    Component: <EditPaymentReceiveEntry />,
    permission: "paymentreceive.edit"
  },
  {
    path: `/ipd/transaction/payment-receive-entry/view/:id`,
    Component: <ViewPaymentReceiveEntry />,
    permission: "paymentreceive.view"
  },

  // room-change-entry
  {
    path: `/ipd/transaction/room-change-entry/add`,
    Component: <AddRoomChangeEntry />,
    permission: "roomchange.add"
  },
  {
    path: `/ipd/transaction/room-change-entry/list`,
    Component: <ListRoomChangeEntry />,
    permission: "roomchange.list"
  },
  {
    path: `/ipd/transaction/room-change-entry/edit/:id`,
    Component: <EditRoomChangeEntry />,
    permission: "roomchange.edit"
  },

  // ipd-bill-charges-entry
  {
    path: `/ipd/transaction/ipd-bill-charges-entry/add`,
    Component: <AddIpdBillChargesEntry />,
    permission: "ipdbillcharges.add"
  },
  {
    path: `/ipd/transaction/ipd-bill-charges-entry/list`,
    Component: <ListIpdBillChargesEntry />,
    permission: "ipdbillcharges.list"
  },
  {
    path: `/ipd/transaction/ipd-bill-charges-entry/edit/:id`,
    Component: <EditIpdBillChargesEntry />,
    permission: "ipdbillcharges.edit"
  },

  // delivery-entry
  {
    path: `/ipd/transaction/delivery-entry/add`,
    Component: <AddDeliveryEntry />,
    permission: "delivery.add"
  },
  {
    path: `/ipd/transaction/delivery-entry/list`,
    Component: <ListDeliveryEntry />,
    permission: "delivery.list"
  },
  {
    path: `/ipd/transaction/delivery-entry/edit/:id`,
    Component: <EditDeliveryEntry />,
    permission: "delivery.edit"
  },

  // patient-history-entry
  {
    path: `/ipd/transaction/patient-history-entry/add`,
    Component: <AddPatientHistoryEntry />,
    permission: "patienthistory.add"
  },
  {
    path: `/ipd/transaction/patient-history-entry/list`,
    Component: <ListPatientHistoryEntry />,
    permission: "patienthistory.list"
  },
  {
    path: `/ipd/transaction/patient-history-entry/edit/:id`,
    Component: <EditPatientHistoryEntry />,
    permission: "patienthistory.edit"
  },

  // ipd-refund-entry
  {
    path: `/ipd/transaction/ipd-refund-entry/add`,
    Component: <AddIpdRefundEntry />,
    permission: "ipdrefund.add"
  },
  {
    path: `/ipd/transaction/ipd-refund-entry/list`,
    Component: <ListIpdRefundEntry />,
    permission: "ipdrefund.list"
  },
  {
    path: `/ipd/transaction/ipd-refund-entry/edit/:id`,
    Component: <EditIpdRefundEntry />,
    permission: "ipdrefund.edit"
  },

  // ipd-discharge-entry
  {
    path: `/ipd/transaction/patient-discharge-entry/add`,
    Component: <AddPatientDischargeEntry />,
    permission: "patientdischarge.add"
  },
  {
    path: `/ipd/transaction/patient-discharge-entry/list`,
    Component: <ListPatientDischargeEntry />,
    permission: "patientdischarge.list"
  },
  {
    path: `/ipd/transaction/patient-discharge-entry/edit/:id`,
    Component: <EditPatientDischargeEntry />,
    permission: "patientdischarge.edit"
  },

  // discharge card entry
  {
    path: `/ipd/transaction/discharge-card-entry/add`,
    Component: <AddDischargeCardEntry />,
    permission: "dischargecard.add"
  },
  {
    path: `/ipd/transaction/discharge-card-entry/list`,
    Component: <ListDischargeCardEntry />,
    permission: "dischargecard.list"
  },
  {
    path: `/ipd/transaction/discharge-card-entry/edit/:id`,
    Component: <EditDischargeCardEntry />,
    permission: "dischargecard.edit"
  },

  // medical certificate entry
  {
    path: `/ipd/transaction/ipd-medical-certificate-entry/add`,
    Component: <AddIpdMedicalCertificateEntry />,
    permission: "ipdmedicalcertificate.add"
  },
  {
    path: `/ipd/transaction/ipd-medical-certificate-entry/list`,
    Component: <ListIpdMedicalCertificateEntry />,
    permission: "ipdmedicalcertificate.list"
  },
  {
    path: `/ipd/transaction/ipd-medical-certificate-entry/edit/:id`,
    Component: <EditIpdMedicalCertificateEntry />,
    permission: "ipdmedicalcertificate.edit"
  },

  //mlc entry
  {
    path: `/ipd/transaction/mlc-entry/add`,
    Component: <AddMlcEntry />,
    permission: "mlc.add"
  },
  {
    path: `/ipd/transaction/mlc-entry/list`,
    Component: <ListMlcEntry />,
    permission: "mlc.list"
  },
  {
    path: `/ipd/transaction/mlc-entry/edit/:id`,
    Component: <EditMlcEntry />,
    permission: "mlc.edit"
  },

  //oxygen given entry
  {
    path: `/ipd/transaction/oxygen-given-entry/add`,
    Component: <AddOxygenGivenEntry />,
    permission: "oxygengiven.add"
  },
  {
    path: `/ipd/transaction/oxygen-given-entry/list`,
    Component: <ListOxygenGivenEntry />,
    permission: "oxygengiven.list"
  },
  {
    path: `/ipd/transaction/oxygen-given-entry/edit/:id`,
    Component: <EditOxygenGivenEntry />,
    permission: "oxygengiven.edit"
  },

  // death certificate entry
  {
    path: `/ipd/transaction/death-certificate-entry/add`,
    Component: <AddDeathCertificateEntry />,
    permission: "deathcertificate.add"
  },
  {
    path: `/ipd/transaction/death-certificate-entry/list`,
    Component: <ListDeathCertificateEntry />,
    permission: "deathcertificate.list"
  },
  {
    path: `/ipd/transaction/death-certificate-entry/edit/:id`,
    Component: <EditDeathCertificateEntry />,
    permission: "deathcertificate.edit"
  },

  // ipd consultant change
  {
    path: `/ipd/transaction/ipd-consultant-change/add`,
    Component: <AddIpdConsultantChange />,
    permission: "ipdconsultantchange.add"
  },
  {
    path: `/ipd/transaction/ipd-consultant-change/list`,
    Component: <ListIpdConsultantChange />,
    permission: "ipdconsultantchange.list"
  },
  {
    path: `/ipd/transaction/ipd-consultant-change/edit/:id`,
    Component: <EditIpdConsultantChange />,
    permission: "ipdconsultantchange.edit"
  }
];

export const ipdReportRoutes = [
  {
    path: `/ipd/reports/ipd-registration-report`,
    Component: <IpdRegistrationReport />,
    permission: "ipdregistrationreport"
  },
  {
    path: `/ipd/reports/birth-report`,
    Component: <BirthReport />,
    permission: "birthreport"
  },
  {
    path: `/ipd/reports/mtp-report`,
    Component: <MtpReport />,
    permission: "mtpreport"
  },
  {
    path: `/ipd/reports/room-change-report`,
    Component: <RoomChangeReport />,
    permission: "roomchangereport"
  },
  {
    path: `/ipd/reports/discharge-report`,
    Component: <DischargeReport />,
    permission: "dischargereport"
  },
  {
    path: `/ipd/reports/discharge-patient-status-report`,
    Component: <DischargePatientStatusReport />,
    permission: "dischargereport"
  },
  {
    path: `/ipd/reports/discharge-patient-dues-report`,
    Component: <DischargePatientDuesReport />,
    permission: "dischargereport"
  },
  {
    path: `/ipd/reports/doctor-wise-patient-status-report`,
    Component: <DoctorWisePatientStatusReport />,
    permission: "dischargereport"
  },
  {
    path: `/ipd/reports/in-patient-report`,
    Component: <InPatientReport />,
    permission: "inpatientreport"
  },
  {
    path: `/ipd/reports/department-census-report`,
    Component: <DepartmentCensusReport />,
    permission: "departmentcensusreport"
  },
  {
    path: `/ipd/reports/discharge-bill-report`,
    Component: <DischargeBillReport />,
    permission: "dischargebillreport"
  },
  {
    path: `/ipd/reports/discount-report`,
    Component: <DiscountReport />,
    permission: "discountreport"
  },
  {
    path: `/ipd/reports/ipd-charges-report`,
    Component: <IpdChargesReport />,
    permission: "ipdchargesreport"
  },
  {
    path: `/ipd/reports/ipd-group-wise-charges-report`,
    Component: <IpdGroupWiseChargesReport />,
    permission: "ipdchargesreport"
  },
  {
    path: `/ipd/reports/ipd-patient-consultant-wise-report`,
    Component: <IpdPatientConsultantWiseReport />,
    permission: "ipdchargesreport"
  },
  {
    path: `/ipd/reports/ipd-patient-receipts-report`,
    Component: <IpdPatientReceiptsReport />,
    permission: "ipdchargesreport"
  },
  {
    path: `/ipd/reports/mlc-report`,
    Component: <MlcReport />,
    permission: "mlcreport"
  },
  {
    path: `/ipd/reports/ipd-refund-report`,
    Component: <IpdRefundReport />,
    permission: "ipdrefundreport"
  },
  {
    path: `/ipd/reports/room-category-wise-report`,
    Component: <RoomCategoryWiseReport />,
    permission: "roomcategorywisereport"
  },

  {
    path: `/ipd/reports/ipd-gender-wise-report`,
    Component: <IpdGenderWiseReport />,
    permission: "ipdgenderwisereport"
  }
];
